import Mixin from 'mixmatch';

export default class Delete extends Mixin {
  async delete(id, object) {
    const options = {
      method: 'DELETE',
      // @ts-ignore
      path: this.member(id),
      // @ts-ignore
      body: this.attributesForObject(object),
    };
    // @ts-ignore
    const body = await this.call(options);
    // @ts-ignore
    return JSON.parse(body)[this.resourceName];
  }
}
